export const hasParamsInUrlUtil: (url:string) => boolean = (url: string): boolean => {
  const urlObj: URL = new URL(url);
  return urlObj.search.length > 0;
}
